var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import environment from '@square/environment-utils/environment';
import Service, { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { assert } from '@ember/debug';
import { tracked } from '@glimmer/tracking';

// The back-end inserts these props into current user data to mark where rails
// permissions start/end. Any props between them are added to this service.
const START_MARKER_PROP = 'startRailsPermissions';
const END_MARKER_PROP = 'endRailsPermissions';

/**
 * https://github.com/squareup/dashboard/blob/main/app/helpers/computed_permissions_helper.rb#L202
 */
let UserRailsPermissions = (_dec = readOnly('currentUserData.data'), _class = class UserRailsPermissions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    _initializerDefineProperty(this, "canUseCardOnFile", _descriptor3, this);
    _initializerDefineProperty(this, "canUseDeviceHub", _descriptor4, this);
    _initializerDefineProperty(this, "canSeePointOfSaleNavigation", _descriptor5, this);
    _initializerDefineProperty(this, "canUsePrinterProfiles", _descriptor6, this);
    _initializerDefineProperty(this, "canUsePrinterProfilesNoRstOrRtl", _descriptor7, this);
    _initializerDefineProperty(this, "canUseDeviceHubNoRstOrRtl", _descriptor8, this);
    _initializerDefineProperty(this, "canSeeProductStore", _descriptor9, this);
    _initializerDefineProperty(this, "canUseDeviceProfilesV2", _descriptor10, this);
    _initializerDefineProperty(this, "canUseDeviceProfilesV2FullGa", _descriptor11, this);
    _initializerDefineProperty(this, "canSeeKdsUpsellWDpv2", _descriptor12, this);
    _initializerDefineProperty(this, "canUseSuperpos", _descriptor13, this);
    _initializerDefineProperty(this, "canViewEmployeePermissions", _descriptor14, this);
    _initializerDefineProperty(this, "canHasCompletedPayrollOnboarding", _descriptor15, this);
    _initializerDefineProperty(this, "isEcomMerchant", _descriptor16, this);
    _initializerDefineProperty(this, "canSeeBasicRestaurantsFeatures", _descriptor17, this);
    _initializerDefineProperty(this, "canAccessCommsAnnouncements", _descriptor18, this);
    _initializerDefineProperty(this, "canAccessCommsSettings", _descriptor19, this);
    _initializerDefineProperty(this, "canSeeInvoices", _descriptor20, this);
    _initializerDefineProperty(this, "canSeeInvoicesCustomizationTab", _descriptor21, this);
    _initializerDefineProperty(this, "canSeeInvoicesEstimateDefaultsTab", _descriptor22, this);
    _initializerDefineProperty(this, "canSeeInvoicesSettingsTabs", _descriptor23, this);
    _initializerDefineProperty(this, "canSeeSellerProjects", _descriptor24, this);
    _initializerDefineProperty(this, "hasJoinedAppointments", _descriptor25, this);
    _initializerDefineProperty(this, "canUseMessenger", _descriptor26, this);
    _initializerDefineProperty(this, "canSeeReleaseManager", _descriptor27, this);
    _initializerDefineProperty(this, "canUseSquareStaff", _descriptor28, this);
    _initializerDefineProperty(this, "canSeeStaffPackagesExperiment", _descriptor29, this);
    _initializerDefineProperty(this, "isStaffPlansEligible", _descriptor30, this);
    _initializerDefineProperty(this, "canSeeAfterpayAbout", _descriptor31, this);
    _initializerDefineProperty(this, "canSeeAfterpayShop", _descriptor32, this);
    _initializerDefineProperty(this, "canSeeEbtSnapFeatures", _descriptor33, this);
    _initializerDefineProperty(this, "canManageTeamMemberFiles", _descriptor34, this);
    _initializerDefineProperty(this, "canManageTeamMemberOnboarding", _descriptor35, this);
    _initializerDefineProperty(this, "canViewTeamMemberFiles", _descriptor36, this);
    _initializerDefineProperty(this, "canSeeServiceLibrary", _descriptor37, this);
    _initializerDefineProperty(this, "canSeeItemDefaultSettings", _descriptor38, this);
    _initializerDefineProperty(this, "isCostPlusMerchant", _descriptor39, this);
    _initializerDefineProperty(this, "isInterchangePlusMerchant", _descriptor40, this);
    _initializerDefineProperty(this, "canSeeConnectedTerminalProfiles", _descriptor41, this);
    _initializerDefineProperty(this, "canUseStandardAppointmentsNav", _descriptor42, this);
    _initializerDefineProperty(this, "canSeeAddMore", _descriptor43, this);
    _initializerDefineProperty(this, "canSeeMcaUk", _descriptor44, this);
    _initializerDefineProperty(this, "hasOnboardedOrderOnline", _descriptor45, this);
    _initializerDefineProperty(this, "canSeeMenusNavigation", _descriptor46, this);
    _initializerDefineProperty(this, "hasCashLocalEnabled", _descriptor47, this);
    _initializerDefineProperty(this, "isCashLocalEligible", _descriptor48, this);
    _initializerDefineProperty(this, "shouldHideCustomersInsights", _descriptor49, this);
    _initializerDefineProperty(this, "canSeeCashLocalNeighborhoodsNavigation", _descriptor50, this);
    _initializerDefineProperty(this, "isCashLocalNeighborhoodsEligible", _descriptor51, this);
    _initializerDefineProperty(this, "isNeighborhoodNetworkEnabled", _descriptor52, this);
    _initializerDefineProperty(this, "canSeeOrderGuide", _descriptor53, this);
    _initializerDefineProperty(this, "hasMigratedSquareOnlineSiteToMenus", _descriptor54, this);
    _initializerDefineProperty(this, "isFranchiseOperatorMerchant", _descriptor55, this);
    _initializerDefineProperty(this, "isFranchiseMerchant", _descriptor56, this);
    _initializerDefineProperty(this, "canSeeSalesChannels", _descriptor57, this);
    const keys = Object.keys(this.data) || [];
    const startIndex = keys.indexOf(START_MARKER_PROP) + 1;
    const endIndex = keys.indexOf(END_MARKER_PROP) - 1;
    if (startIndex >= endIndex && !environment().isTesting) {
      // this should Never Happen™, but if it does then the data is meaningless
      assert('Current user data does not have start/end marker props for rails permissions');
    }

    // hashtable object with string keys and boolean values
    const props = {};
    for (let i = startIndex; i <= endIndex; i++) {
      const key = keys[i];
      props[key] = this.data[key];
    }

    // yes, this is cheating typescript
    Object.assign(this, props);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canUseCardOnFile", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceHub", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canSeePointOfSaleNavigation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "canUsePrinterProfiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "canUsePrinterProfilesNoRstOrRtl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceHubNoRstOrRtl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "canSeeProductStore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceProfilesV2", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "canSeeKdsUpsellWDpv2", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "canUseSuperpos", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "canViewEmployeePermissions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "canHasCompletedPayrollOnboarding", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "isEcomMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "canSeeBasicRestaurantsFeatures", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "canAccessCommsAnnouncements", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "canAccessCommsSettings", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoices", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoicesCustomizationTab", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoicesEstimateDefaultsTab", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoicesSettingsTabs", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "canSeeSellerProjects", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "hasJoinedAppointments", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "canUseMessenger", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "canSeeReleaseManager", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "canUseSquareStaff", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "canSeeStaffPackagesExperiment", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "isStaffPlansEligible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "canSeeAfterpayAbout", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "canSeeAfterpayShop", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "canSeeEbtSnapFeatures", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "canManageTeamMemberFiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "canManageTeamMemberOnboarding", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "canViewTeamMemberFiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "canSeeServiceLibrary", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "canSeeItemDefaultSettings", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "isCostPlusMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "isInterchangePlusMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "canSeeConnectedTerminalProfiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "canUseStandardAppointmentsNav", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "canSeeAddMore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "canSeeMcaUk", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "hasOnboardedOrderOnline", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "canSeeMenusNavigation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "hasCashLocalEnabled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "isCashLocalEligible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "shouldHideCustomersInsights", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "canSeeCashLocalNeighborhoodsNavigation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "isCashLocalNeighborhoodsEligible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "isNeighborhoodNetworkEnabled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "canSeeOrderGuide", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "hasMigratedSquareOnlineSiteToMenus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "isFranchiseOperatorMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "isFranchiseMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "canSeeSalesChannels", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UserRailsPermissions as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.